import { render, staticRenderFns } from "./MotionOpacity.vue?vue&type=template&id=a3b313b6"
import script from "./MotionOpacity.vue?vue&type=script&lang=js"
export * from "./MotionOpacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports